import {Parent} from '@/scripts/types/process-builder';
import {Graph, ProcessElementType, Variable} from '@/scripts/types/generated';
import {MenuItem} from '@/scripts/types/helper.ts';

export const useProcess = () => {
	const {getActivityVariables, getActivity} = useActivities();
	const {getGatewayVariables, getGateway} = useGateways();

	const getShowRoute = (ancestors: Parent[]) => {
		return route('tenant.processes.show', {
			processVersion: ancestors[0].versionUuid,
			workflowVersions:
				ancestors.length > 1
					? ancestors
							.slice(1)
							.map((ancestor) => ancestor.versionUuid)
							.join('/')
					: null,
		});
	};

	const getAncestorBreadcrumb = (ancestors: Parent[]): MenuItem => {
		const current = ancestors[ancestors.length - 1];

		return {
			label: current.name,
			url: getShowRoute(ancestors),
		};
	};

	const getAncestorBreadcrumbs = (ancestors: Parent[]): MenuItem[] => {
		const breadcrumbs: MenuItem[] = [];

		for (let i = 0; i < ancestors.length; i++) {
			breadcrumbs.push(getAncestorBreadcrumb(ancestors.slice(0, i + 1)));
		}

		return breadcrumbs;
	};

	const isProcessElement = (type: ProcessElementType) => {
		return !['start', 'end'].includes(type);
	};

	const getGraphVariables = async (graph: Graph): Promise<Variable[]> => {
		let variables: Set<Variable> = new Set();

		for (const node of graph.nodes) {
			switch (node.data.processElementType) {
				case 'activity':
					variables = new Set<Variable>([
						...variables,
						...(await getActivityVariables(
							await getActivity(
								node.data.processElementVersionUuid
							)
						)),
					]);
					break;
				case 'gateway':
					variables = new Set<Variable>([
						...variables,
						...getGatewayVariables(
							await getGateway(
								node.data.processElementVersionUuid
							)
						),
					]);
					break;
			}
		}

		return [...variables];
	};

	return {
		getShowRoute,
		isProcessElement,
		getGraphVariables,
		getAncestorBreadcrumbs,
	};
};
